import MobileSectionsList from './MobileSectionsList';

export default MobileSectionsList;
